import { render, staticRenderFns } from "./TemplateVarVariantsContainer.vue?vue&type=template&id=26815de0"
import script from "./TemplateVarVariantsContainer.vue?vue&type=script&lang=js"
export * from "./TemplateVarVariantsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports